import { useCustomNavigation } from "@/hooks/useCustomNavigation";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "./settings.scss";
import { useAuth } from "@/context/auth.context";

const Settings = () => {
  const appVersion = process.env.REACT_APP_VERSION;

  const { navigateBack } = useCustomNavigation();
  const { user } = useAuth();
  return (
    <div
      style={{ background: "var(--sm-bg, rgba(240, 242, 250, 0.8))" }}
      className="main-grid"
    >
      <div className="settings-header-wrap">
        <div onClick={navigateBack} className="settings-header-container">
          <ChevronLeftIcon className="back-icon" />
          <h2>Settings</h2>
        </div>
      </div>
      <div className="settings-main-wrap">
        <div className="content">
          <div className="account-security">
            <h2>Account & Security</h2>
            <div className="menu-wrap">
              <div className="menu-item">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.truetoform.fit/terms-of-use"
                >
                  Terms of Use <ArrowForwardIosIcon className="arrow-icon" />
                </a>
              </div>
              <div className="menu-item">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.truetoform.fit/privacy-policy"
                >
                  Privacy Policy <ArrowForwardIosIcon className="arrow-icon" />
                </a>
              </div>
            </div>

            <div className="menu-wrap1">
              <div className="menu-item">
                <a href="/contact-us">
                  Contact Us <ArrowForwardIosIcon className="arrow-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="settings-footer-container">
        <div className="footer-item">App Version {appVersion}</div>
        <div className="footer-item">ID {user?.uid}</div>
      </div>
    </div>
  );
};

export default Settings;
